import { Group, Stack, Text } from "@mantine/core"
import { IconBriefcase, IconMail, IconUsers } from "@tabler/icons-react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

type ContactCardProps = {
  contact: LibraryResponses.SupplierDetails
}

export function ContactCard({ contact }: ContactCardProps) {
  return (
    <>
      <Group wrap="nowrap">
        <Stack>
          <Group>
            <IconBriefcase color="var(--tag-color-info)" size={16} />
            <Text
              fw={700}
              style={{
                overflow: "",
                wordBreak: "break-all",
              }}
            >
              {contact.organization.length > 0 ? contact.organization : "N/A"}
            </Text>
          </Group>
          <Group>
            <IconUsers color="var(--icon-info-color)" size={16} />
            <Text
              fw={500}
              style={{
                overflow: "",
                wordBreak: "break-all",
              }}
            >
              {contact.name.length > 0 ? contact.name : "N/A"}
            </Text>
          </Group>
          <Group>
            <IconMail color="var(--icon-info-color)" size={16} />
            <Text
              fw={500}
              style={{
                overflow: "",
                wordBreak: "break-all",
              }}
            >
              {contact.email}
            </Text>
          </Group>
        </Stack>
      </Group>
    </>
  )
}
